import { render, staticRenderFns } from "./CampoPropietario.vue?vue&type=template&id=9616cd84"
import script from "./CampoPropietario.vue?vue&type=script&lang=js"
export * from "./CampoPropietario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports